<script>
  import axios from "axios"
  import ApplicationState from "../../../../../Stores/applicationStates"
  import Footer from "../../../../../Shared/footer.svelte"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import Counter from "../../Shared/counter2.svelte"
  import notify from "../../../../../Script/notify"
  import { afterUpdate, onMount } from "svelte"
  import { push, querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../../Script/queryString"
  import bulkJson from "../../Stores/jsonBulkData"
  import { loadJs } from "../../../../../Script/loadLibrary"
  import { capitalizeArrayEntries } from "../../Script/bulkUpload"
  import { flatenObject } from "../../../../../Script/flatenObject"
  import List from "./Components/list.svelte"
  import Table from "../../../../../Shared/TableWithoutApi/index.svelte"
  import Loader from "../../../../../Shared/Slots/loader.svelte"
  import { fetchBulkStatus, fetchBulkTemplate, generateXlFile, fetchSelectedDocumentTemp, fetchFileTemplate, fetchSingleFont } from "../../Script/bulkUpload"
  import ConfirmationModal from "../../Shared/confirmationModal.svelte"
  import Dropdown from "./Components/fileTypeDropdown.svelte"
  import { loadQR, loadImage } from "../../Script/bulkUpload"
  import DownloadConfirm from "../../Shared/downloadConfirm.svelte"
  import EmailConfirmationModel from "../../Shared/EmailConfirmationModel.svelte"
  import { loadTooltip } from "../../../../../Script/loadTooltip"
  import EmailDropdown from "./Components/emailDropdown.svelte"
  /**
   * @type {Number} the total number of documents to be uploaded
   */
  let totalDoc = 0
  /**
   * @type {Boolean} whether to show email button or not
   */
  let showEmailButton
  /**
   * @type {Object} object of query in current page url
   */
  let query
  /**
   * @type {Boolean} whether to show toggle or not
   */
  let showLoading = false
  /**
   * @type {String} the text to be shown while loading
   */
  let loadingText

  let bulkData
  /**
   * @type {Boolean} whether to show reset button or not
   */
  let showResetButton = false
  /**
   * @type {Boolean} whether to show confirmation modal or not
   */
  let showConfirmationModal = false
  /**
   * @type {Number} which type of zip file going to download
   */
  let downloadType = "Image"
  /**
   * @type {JSZip} Create a new instance of JSZip for working with ZIP files.
   */
  let zip

  let img

  let initialValue = 0

  let showDocumentModal = false
  let emailRemoveConfirmationModel = false
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let downloadInProcess = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let jsonForDownload = []

  let timerDownload

  let showDownloadBtn = false

  let showRevocationConfirmModal = false

  let bulkStatus

  let revokedDocs = 0

  onMount(async () => {
    try {
      // Set showLoading to true to indicate loading state
      showLoading = true

      // Set loadingText to indicate the current loading step
      loadingText = "Fetching Bulk Upload data&nbsp;&nbsp;"
      // Parse the query parameters from the URL using a function called `queryStringToJSON`.
      query = queryStringToJSON($querystring)

      // If the 'id' parameter is missing in the query, redirect the user to "/publish/bulk".
      if (!query.id) {
        push("/publish/bulk")
        return
      }

      // Fetch data about the bulk publishing status using the 'id' from the query
      let apiData = await fetchBulkStatus(query.id)

      // Check if the bulk publishing status is "started"
      if (apiData.status == "started") {
        // Redirect to upload file or generate file page based on the "generateFile" flag
        if (!apiData.generateFile) push(`/publish/bulk/upload-file?id=${query.id}`)
        else push(`/publish/bulk/generate-file?id=${query.id}`)
        return
      }

      // Check if the bulk publishing status is "uploaded"
      if (apiData.status == "uploaded") {
        // Redirect to sign and publish page
        push(`/publish/bulk/sign-publish?id=${query.id}`)
        return
      }

      showResetButton = apiData.status == "active"

      // Determine whether to show an email button based on data from the fetched bulkData.
      showEmailButton = apiData.sendEmail

      // Fetch bulk template data based on the 'id' parameter from the query.
      // The data seems to be related to sending bulk emails.
      bulkData = await fetchBulkTemplate(query.id)

      bulkStatus = bulkData.bulk.status

      // console.log(bulkStatus)

      showDownloadBtn = bulkData.bulk.generateFile

      // Store the array of documents from the fetched bulkData.
      $bulkJson = [...bulkData.documents]

      let revokedDocList = $bulkJson.filter((document) => !document.notRevoked) || []

      revokedDocs = revokedDocList.length

      // Initialize counters for total documents, generated signatures, and published documents.
      totalDoc = $bulkJson.length
    } catch (error) {
      const info = "PAGE: Bulk Report\nEVENT: onMount"
      // Display a danger notification with the error message
      notify.danger(error, info)

      // Redirect to the bulk publishing page in case of an error
      push("/publish/bulk")
    } finally {
      // Set showLoading back to false to end the loading state
      showLoading = false
    }
  })

  /**
   * Function to download an Excel sheet using exceljs library
   */
  const downloadSheet = async () => {
    try {
      // Check if exceljs library is already loaded. If not, load it dynamically.
      await loadJs("ExcelJS", "assets/lib/exceljs.min.js")

      const firstMeta = flatenObject(JSON.parse($bulkJson[0].metadata))
      const firstOptions = flatenObject(JSON.parse($bulkJson[0].options))

      const metaKeys = Object.keys(firstMeta)
      const optionKeys = Object.keys(firstOptions)

      const headerKeys = [...metaKeys, ...optionKeys]

      if (bulkData.bulk.sendEmail) headerKeys.push("emailSent")
      headerKeys.push("revokationStatus", "documentUrl")

      const header = capitalizeArrayEntries(headerKeys)

      // const sortedData = [...$bulkJson].sort((a, b) => {
      //   const metaA = flatenObject(JSON.parse(a.metadata))
      //   const metaB = flatenObject(JSON.parse(b.metadata))

      //   const nameA = (metaA["receiver_name"] ?? "").toString().toLowerCase()
      //   const nameB = (metaB["receiver_name"] ?? "").toString().toLowerCase()

      //   return nameA.localeCompare(nameB)
      // })

      let ValuesArr = []

      for (const row of $bulkJson) {
        const metadata = flatenObject(JSON.parse(row.metadata))
        // console.log({ metadata })

        const options = flatenObject(JSON.parse(row.options))

        if (options.date) {
          options.date = new Date(options.date).toDateString().slice(4)
        }

        options.expireOn = options.expireOn ? new Date(options.expireOn).toDateString().slice(4) : "Nil"

        const combinedRow = {
          ...metadata,
          ...options,
          emailSent: row.emailState ? "Successfully Sent" : "Not yet sent",
          revokationStatus: row.notRevoked ? "Active" : "Revoked",
          documentUrl: row.url,
        }

        const values = headerKeys.map((key) => combinedRow[key] || "-")
        ValuesArr.push(values)
      }

      // Generate Excel
      if (header.length !== ValuesArr[0]?.length) {
        throw "Header and row values length mismatch"
      }

      // Call the generateXlFile function to create and download the Excel file
      await generateXlFile(header, ValuesArr, query.id)
    } catch (error) {
      const info = "PAGE: Bulk Report\nEVENT: While downloading bulk report"
      // console.error(error)
      notify.danger(error, info)
    }
  }

  const whileConfirm = async () => {
    try {
      showEmailButton = true
      showResetButton = false
      showConfirmationModal = false

      // Set showLoading to true to indicate loading state
      showLoading = true

      await fetchBulkStatus(query.id, true)

      window.location.reload()
    } catch (error) {
      const info = "PAGE: Bulk Report\nEVENT: While updating bulk status and enabling Resend email"
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  const loadLibraries = async () => {
    try {
      // Load JSZip library if it's not already loaded
      await loadJs("JSZip", "assets/lib/jszip.min.js")

      // Load FileSaver library if it's not already loaded
      await loadJs("FileSaver", "assets/lib/FileSaver.min.js")
    } catch (error) {
      // console.error(error)
      throw error
    }
  }

  const createZIPIns = async (type) => {
    try {
      // Create a new JSZip instance
      zip = new JSZip()

      // Add a 'Read Me.txt' file to the zip with some initial content
      zip.file("Read Me.txt", "Documents Generated by Docchain.io\n")

      // Create a folder named 'images' inside the zip
      img = zip.folder(type == "qr" ? "Qr Image" : downloadType)
    } catch (error) {
      // console.error(error)
      throw error
    }
  }

  /**
   * Function for generating the file using canvas
   * @param {import("../../Script/document").bulkDocument} data
   */
  const generateFile = (docData) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

        // For documents download, fetch the data using axios from a specified URL and add it as a file to the zip
        const { data } = await axios.get(`/ipfs/${docData.filename}`, { responseType: "blob" })

        let file

        if (downloadType == "Image") {
          // Create a new File object with the Blob and provide a default filename and type
          file = new File([data], `${docData.id}.jpeg`, {
            type: "image/jpeg",
          })
        } else {
          let blobURL = URL.createObjectURL(data)

          file = await imageToPdf(blobURL, docData)
        }

        resolve(file)
      } catch (error) {
        reject(error)
      }
    })
  }

  const imageToPdf = async (imageUrl, data) => {
    try {
      const { jsPDF } = window.jspdf

      const img = await loadImage(imageUrl)

      // Create an off-screen canvas to draw the image
      const canvas = document.createElement("canvas")
      const context = canvas.getContext("2d")

      // Set canvas dimensions to image dimensions
      canvas.width = img.naturalWidth
      canvas.height = img.naturalHeight

      // Draw the image onto the canvas
      context.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight)

      // Get the image data URL
      const imgData = canvas.toDataURL("image/jpeg")

      // Create a new jsPDF instance
      const doc = new jsPDF({
        orientation: canvas.width > canvas.height ? "landscape" : "portrait",
        unit: "px",
        format: [canvas.width, canvas.height],
      })

      // Add image to PDF
      await doc.addImage(imgData, "JPEG", 0, 0, canvas.width, canvas.height)

      const pdfBlob = doc.output("blob")

      const pdfFile = new File([pdfBlob], `document-${data.recName}.pdf`, { type: "application/pdf" })

      // Generate the PDF as a Blob
      return pdfFile
    } catch (error) {
      // console.error(error)
      throw error
    }
  }

  const downloadDocuments = async () => {
    try {
      showDocumentModal = false

      // Set a flag to show loading while the download is in progress
      showLoading = true

      // Define loading text based on the download type (qr or documents)
      // loadingText = "Downloading Documents 0%&nbsp;"

      await loadLibraries()

      if (downloadType == "PDF") {
        await loadJs("jspdf", "assets/lib/jspdf.umd.min.js")
        await loadJs("html2canvas", "assets/lib/html2canvas.min.js")
      }

      await createZIPIns("document")

      for (let i = 0; i < $bulkJson.length; i++) {
        $bulkJson[i].generatedFile = false
      }

      jsonForDownload = [...$bulkJson]

      // console.time("download")

      timerDownload = setInterval(initiateDownload, 30)
    } catch (error) {
      // console.error(error)
      const info = "PAGE: Bulk Report\nEVENT: While downloading documents as zip"
      // If there's an error, log the error and display an error notification
      notify.danger(error, info)

      // Reset the loading flag to false when download is complete or if there's an error
      showLoading = false
    }
  }

  /**
   * Initiates the document download process, generates a ZIP, and triggers the download.
   */
  const initiateDownload = async () => {
    // Filter documents that haven't been generated yet
    let tobeProcessed = $bulkJson.filter((a) => !a.generatedFile)

    // Set loading text based on the number of documents to download
    if ($bulkJson.length > 1000) {
      let finalCount = initialValue + 1000 > totalDoc ? totalDoc : initialValue + 1000
      loadingText = `Downloading Documents ${initialValue + 1} - ${finalCount} &nbsp;&nbsp;`
    } else {
      if ($bulkJson.length == 1) loadingText = `Downloading Document &nbsp;`
      else loadingText = `Downloading Documents 1 - ${$bulkJson.length}&nbsp;&nbsp;`
    }

    // Check if there is data to download or if the download is in progress
    if (jsonForDownload.length || tobeProcessed.length || downloadInProcess.length) assignDownloadData2Array()
    else {
      clearInterval(timerDownload)
      // The download process has completed
      // console.timeEnd("download")
      // console.log("completed")

      // If the number of documents is less than or equal to 1000, generate and trigger the download
      // if ($bulkJson.length <= 1000) {

      await zip.generateAsync({ type: "blob" }).then(function (content) {
        // Save the generated content as a ZIP file with a specific name
        saveAs(content, `Bulk-${query.id}.zip`)
      })
      // zip.generateAsync({ type: "blob" }).then(function (content) {
      //   // Save the generated content as a ZIP file with a specific name
      //   saveAs(content, `Bulk-${query.id}.zip`)
      // })
      // }

      // Set showLoading to false to end the loading state
      showLoading = false
    }
  }

  const assignDownloadData2Array = async () => {
    try {
      // Get the number of available hardware threads or cores
      let hwc = window.navigator.hardwareConcurrency >= 4 ? 4 : window.navigator.hardwareConcurrency
      // let hwc = window.navigator.hardwareConcurrency

      // Assign files to the downloadInProcess array if it has fewer elements than the available hardware threads
      if (downloadInProcess.length < hwc) {
        // Extract a portion of jsonData to fill up to (hwc - downloadInProcess.length) elements
        let dArray = jsonForDownload.splice(0, hwc - downloadInProcess.length)

        // Add the extracted elements to the downloadInProcess array
        downloadInProcess = [...downloadInProcess, ...dArray]

        // Process each element of fArray by calling the getFileHash function
        for (let i = 0; i < dArray.length; i++) {
          if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
          generateFileForDownloading(dArray[i])
        }
      }
    } catch (error) {
      const info = "PAGE: Bulk Report\nEVENT: While processing and generating documents to download as zip"
      notify.danger(error, info)
      showLoading = false
    }
  }

  /**
   * Function for generating file and then download
   * @param {import("../../Script/document").bulkDocument} data
   */
  const generateFileForDownloading = async (data) => {
    try {
      let generatedFile = await generateFile(data)

      img.file(data.recName + "-" + Math.floor(Math.random() * 10000) + `${downloadType == "Image" ? ".jpg" : ".pdf"}`, generatedFile, { binary: true })

      // Check if the total number of documents is greater than 1000
      if ($bulkJson.length > 1000) {
        // Check if the number of files in the 'images' folder is 1000
        if (Object.keys(img.files).length - 2 == 1000) {
          // Generate the zip file asynchronously and save it using FileSaver.js
          zip.generateAsync({ type: "blob" }).then(function (content) {
            saveAs(content, `Bulk-${query.id}.zip`) // Save the zip as 'Documents.zip'
          })

          // Create a new JSZip instance
          zip = new JSZip()

          // Add a 'Read Me.txt' file to the zip with some initial content
          zip.file("Read Me.txt", "Documents Generated by Docchain.io\n")

          // Create a folder named 'images' inside the zip
          img = zip.folder(downloadType)

          // Update the 'initialValue' for tracking document ranges
          initialValue = initialValue + 1000
        }
      }
    } catch (error) {
      // Handle any errors that may occur during the file generation
      // console.error(error)
      throw error
    } finally {
      // Find the document to be updated in the $bulkJson array
      let tobeUpdated = $bulkJson.filter((a) => a.id == data.id)[0]

      // Set the "generatedFile" property to true for the updated document
      tobeUpdated.generatedFile = true

      // Update the $bulkJson array with the updated document
      $bulkJson = [tobeUpdated, ...$bulkJson.filter((a) => a.id != data.id)]

      // Remove the current file entry from the 'fileInProcess' array based on its ID
      downloadInProcess = downloadInProcess.filter((a) => a.id != data.id)

      // loadingText = `Downloading Documents ${(($bulkJson.length - downloadInProcess.length) / $bulkJson.length) * 100}%&nbsp;`
    }
  }

  const removeEmail = async () => {
    try {
      emailRemoveConfirmationModel = false

      // Set showLoading to true to indicate loading state
      showLoading = true

      await fetchBulkStatus(query.id, false, true)

      window.location.reload()
    } catch (error) {
      const info = "PAGE: Bulk Report\nEVENT: While updating bulk status and marking emails as sent"
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })
</script>

<svelte:head>
  <title>Bulk Report</title>
</svelte:head>
{#if showDocumentModal}
  <DownloadConfirm
    {totalDoc}
    on:click={() => {
      showDocumentModal = false
    }}
    on:download={downloadDocuments}
  />
{/if}

{#if emailRemoveConfirmationModel}
  <EmailConfirmationModel
    on:click={() => {
      emailRemoveConfirmationModel = false
    }}
    on:remove={removeEmail}
  />
{/if}

<!-- content="Would you like to resend all the <strong>Emails</strong> related to these bulk documents?" -->
{#if showConfirmationModal}
  <ConfirmationModal
    title="Enable Resend Emails For Bulk Documents"
    content="The option to resend emails is currently disabled. Would you like to enable this option? Once enabled, you will be able to resend the selected emails to the original recipients. Click <strong>Confirm</strong> to enable the resend option."
    on:click={() => {
      showConfirmationModal = false
    }}
    on:confirm={whileConfirm}
  />
{/if}

{#if showRevocationConfirmModal}
  <ConfirmationModal
    title="Revoke Bulk Document"
    content="Would you like to revoke all documents associated with the bulk template named <strong>{bulkData.bulk.name}</strong>?"
    on:click={() => {
      showRevocationConfirmModal = false
    }}
    on:confirm={() => {
      showRevocationConfirmModal = false
      push(`/publish/bulk/revoke?id=${bulkData.bulk.id}`)
    }}
  />
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  <div class="flex px-6 pb-12 pt-9">
    <div class="relative mx-auto flex w-full max-w-[920px] flex-col justify-between rounded-md bg-white dark:bg-mdGray">
      {#if showLoading}
        <div class="flex h-full items-center justify-center text-base text-gray-400">
          <Loader>
            <span class="flex">
              {@html loadingText}
            </span>
          </Loader>
        </div>
      {:else}
        <div class="flex h-full w-full select-none flex-col items-center justify-center p-6 mobile:p-12">
          <div class="grid w-full grid-cols-3 justify-center gap-3 xl:gap-6">
            <Counter titleText="TOTAL DOCUMENTS" span="col-span-3" count={totalDoc} color="#ff6a00" gradient="#f8a500, #ff6a00" icon="fa-file-lines" />
            <Counter titleText="DOCUMENTS PUBLISHED" span="col-span-3" count={totalDoc} color="#00D515" gradient="#58FE69, #00D515" icon="fa-file-check" />
            <Counter titleText="DOCUMENTS REVOKED" span="col-span-3" count={revokedDocs} color="#00B2FF" gradient="#A3E3FF, #00B2FF" icon="fa-file-excel" />
          </div>

          <div class="mt-12 mb-6 flex w-full flex-wrap justify-center gap-3">
            {#if showEmailButton}
              {#if !showResetButton}
                <div class="relative flex w-fit">
                  <EmailDropdown
                    on:click={() => {
                      push(`/publish/bulk/send-email?id=${query.id}`)
                    }}
                    on:change={() => {
                      emailRemoveConfirmationModel = true
                    }}
                  />
                </div>
              {:else}
                <button
                  name="tooltip"
                  id="Emails Sent, Enable Resend"
                  tooltip-position="top"
                  on:click={() => {
                    showConfirmationModal = true
                  }}
                  type="button"
                  class="normal-blue-btn disabled:text-white-200/50 disabled:cursor-not-allowed disabled:bg-blue-200/50"
                >
                  <i class="fa-solid fa-rotate-left" />
                  <span class="hidden select-none lg:block">&nbsp;&nbsp;Emails&nbsp;Sent,&nbsp;Enable&nbsp;Resend</span>
                </button>
              {/if}
            {/if}

            {#if showDownloadBtn}
              <div class="relative flex w-fit">
                <Dropdown
                  title="Download Documents"
                  bind:activeItem={downloadType}
                  on:change={() => {
                    initialValue = 0
                    showDocumentModal = true
                  }}
                />
              </div>
            {/if}

            <button
              on:click={() => {
                showRevocationConfirmModal = true
              }}
              name="tooltip"
              disabled={["started", "uploaded", "revoked"].includes(bulkStatus)}
              id="Revoke Documents"
              tooltip-position="top"
              type="button"
              class="disabled:text-white-200/50 flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-red-500 px-4 text-sm font-medium text-white hover:bg-red-600 hover:text-white focus:outline-none active:bg-red-500 disabled:cursor-not-allowed disabled:bg-red-400"
            >
              <i class="fa-solid fa-file-excel" />
              <span class="hidden select-none lg:block">&nbsp;&nbsp;{bulkStatus == "revoked" ? "Revoked" : "Revoke"}&nbsp;Documents&nbsp;</span>
            </button>
            <button name="tooltip" id="Download Report" tooltip-position="top" on:click={downloadSheet} type="button" class="disabled:text-white-200/50 flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-4 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-200/50">
              <i class="fa-solid fa-download" />
              <span class="hidden select-none lg:block">&nbsp;&nbsp;Download&nbsp;Report&nbsp;</span>
            </button>
          </div>

          <Table list={List} jsonData={$bulkJson} dateSort={false} sortNameParam="recName" searchParam="recName" />
        </div>
      {/if}
    </div>
  </div>

  <Footer />
</div>

<style lang="postcss">
  .normal-blue-btn {
    @apply flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-4 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500;
  }
  .normal-blue-dropdown-btn {
    @apply flex h-9 items-center justify-center rounded-l-md border border-[#a0a1a580] bg-blue-500 px-4 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 md:min-w-fit;
  }
</style>
